import { render, staticRenderFns } from "./CarView.vue?vue&type=template&id=cda70e96&scoped=true&"
import script from "./CarView.vue?vue&type=script&lang=js&"
export * from "./CarView.vue?vue&type=script&lang=js&"
import style0 from "./CarView.vue?vue&type=style&index=0&id=cda70e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda70e96",
  null
  
)

export default component.exports